// asset-owners/search — the fields an owner is searched by, ONE function both
// faces call (ADR-072 §6 · ADR-045): the name by its words (a mistake forgiven),
// the finance code a KEY — unique per owner (`uq_asset_owners_code_ci`), so
// typed whole it answers alone, typed in part it matches as a code, never
// forgiven. The owners page's `useListController` and the owners export's
// `matchRows`; the server's own search holds the same split in its columns.
export function assetOwnerSearchFields(o) {
    return { name: o.name, codes: [o.code], keys: [o.code] };
}
